// Redirige a la página de listado de usuarios
export function usuarioRedirections() {
    window.location.href = `/usuario`;

}

export function iniciarSesion(){
    window.open(`/login`, '_self');
}

export function registro(){
    window.open(`/registro`, '_self');
}

export function home(){
    window.open(`/`, '_self');
}

export function creditoUsuario(){
    window.open(`/usuario/credito`, '_blank');
}

export function creditoUsuarioRedireccion(){
    window.location.href = '/usuario/credito';
}

export function historialUsuario(){
    window.location.href = '/usuario/historial';
}

